import React, { useState, useCallback } from 'react';
import { CloseIcon } from '../SVGIcons/SVGIcons';
import Button from '../Button';
import { useUiVersionToggle } from '../../hooks/useUiVersionToggle';

const DISMISS_KEY = 'uiVersionBannerDismissed';

export default function UiVersionBanner() {
	const { toggleUiVersion, isPending } = useUiVersionToggle();

	// Initialize from localStorage once
	const [visible, setVisible] = useState(() => {
		if (typeof window === 'undefined') return true;
		return localStorage.getItem(DISMISS_KEY) === 'true' ? false : true;
	});

	const handleTryNow = useCallback(
		(e) => {
			e.stopPropagation();
			toggleUiVersion(true); // force V2 explicitly
		},
		[toggleUiVersion]
	);

	const handleClose = useCallback((e) => {
		e.stopPropagation();
		localStorage.setItem(DISMISS_KEY, 'true');
		setVisible(false);
	}, []);

	// Early return AFTER hooks
	// if (!visible) {
	// 	return null;
	// }

	return (
		<div className='bannerCont'>
			<div className='bannerText'>
				<p className='thickText'>Our new design is here!</p>
				{/* <p className='thinText'>Learn about it and how you can switch back.</p>
				 */}
				<p className='thinText'>
					The new version of Procuur is available. You can toggle between it and this 1.0 design
				</p>
			</div>

			<div className='bannerActions'>
				<Button
					text={isPending ? 'Switching…' : 'Try now'}
					theme='accent'
					onClick={handleTryNow}
					disabled={isPending}
				/>
			</div>

			{/* <div className='bannerClose' onClick={handleClose}>
				<CloseIcon iconClass='closeIcon' />
			</div> */}
		</div>
	);
}
